import React, { FC } from 'react';
import EachTaskGroup from './EachTaskGroup';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import EachWOTask from './EachWOTask';

const GroupedTaskDisplay: FC<any> = ({
	groupedTasks,
	onEditTask,
	onDeleteTask,
	onAddNewTask = () => {},
	isAllowedToEdit,
	changeTitleForExistingTasks,
	timeZoneId,
	notCheckable,
	onGroupDelete,
	onShowAssociate,
	workOrder,
	associationDisabled,
	addGroupDisabled,
	hideIndividualWalkthroughLink,
}): React.ReactElement => {
	return (
		<>
			{groupedTasks
				.filter((_) => !!_.groupTitle)
				.map((group, idx) => (
					<EachTaskGroup
						key={group.groupTitle}
						group={group}
						onTaskEdit={onEditTask}
						onTaskDelete={onDeleteTask}
						addNewTask={onAddNewTask}
						isAllowedToEdit={isAllowedToEdit}
						onEditGroupTitleComplete={changeTitleForExistingTasks}
						timeZoneId={timeZoneId}
						notCheckable={notCheckable}
						onGroupDelete={onGroupDelete}
						onShowAssociate={onShowAssociate}
						workOrder={workOrder}
						associationDisabled={associationDisabled}
						addGroupDisabled={addGroupDisabled}
						hideIndividualWalkthroughLink={hideIndividualWalkthroughLink}
					/>
				))}
			{nullSafeGetOrElse(
				'tasks',
				groupedTasks.find((_) => !_.groupTitle),
				[]
			).map((task, idx) => (
				<EachWOTask
					key={`task-item-ungrouped-${task.id || task.orderingId}`}
					task={task}
					onTaskEdit={onEditTask}
					onTaskDelete={onDeleteTask}
					onEnter={onAddNewTask('')}
					canEdit={isAllowedToEdit}
					timeZoneId={timeZoneId}
					notCheckable={notCheckable}
					onShowAssociate={onShowAssociate}
					workOrder={workOrder}
					associationDisabled={associationDisabled}
					addGroupDisabled={addGroupDisabled}
					hideIndividualWalkthroughLink={hideIndividualWalkthroughLink}
				/>
			))}
		</>
	);
};

export default GroupedTaskDisplay;
